import { kgToLbs, lbsToKg, cmToFtIn, ftInToCm } from "../dataStore"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  getConvertedWeights() {
    if (!this.store.isMetric) {
      const { weightKg } = this.formValues

      const weightLbs = Math.round(kgToLbs(weightKg || 0))

      return weightLbs
    } else {
      const { weightLbs } = this.formValues

      const weightKg = Math.round(lbsToKg(weightLbs || 0))

      return weightKg
    }
  },

  getConvertedHeights() {
    if (!this.store.isMetric) {
      const { heightCm } = this.formValues

      const imperialHeight = cmToFtIn(heightCm || 0)
      const heightFt = imperialHeight.heightFt
      const heightIn = imperialHeight.heightIn

      return { heightFt, heightIn }
    } else {
      const { heightFt, heightIn } = this.formValues

      const heightCm = ftInToCm({ ft: heightFt || 0, inch: heightIn || 0 })

      return heightCm
    }
  },

  convertHeight() {
    if (!this.store.isMetric) {
      const { heightFt, heightIn } = this.getConvertedHeights()
      const weightLbs = this.getConvertedWeights()

      this.formValues.heightFt = heightFt
      this.formValues.heightIn = heightIn
      this.formValues.weightLbs = weightLbs
    } else {
      const heightCm = this.getConvertedHeights()
      const weightKg = this.getConvertedWeights()

      this.formValues.heightCm = heightCm
      this.formValues.weightKg = weightKg
    }
  },

  convertWeight() {
    if (!this.store.isMetric) {
      const { heightFt, heightIn } = this.getConvertedHeights()
      const weightLbs = this.getConvertedWeights()

      this.formValues.heightFt = heightFt
      this.formValues.heightIn = heightIn
      this.formValues.weightLbs = weightLbs
    } else {
      const heightCm = this.getConvertedHeights()
      const weightKg = this.getConvertedWeights()

      this.formValues.heightCm = heightCm
      this.formValues.weightKg = weightKg
    }
  },

  processFormValues() {
    const { age, firstName, heightCm, heightFt, heightIn, weightKg, weightLbs } = this.formValues

    if (this.store.isMetric) {
      const imperialHeight = cmToFtIn(heightCm)
      const convertedHeightFt = imperialHeight.heightFt
      const convertedHeightIn = imperialHeight.heightIn
      const convertedWeightLbs = Math.round(kgToLbs(weightKg))

      return {
        heightFt: convertedHeightFt,
        heightIn: convertedHeightIn,
        heightCm,
        weightLbs: convertedWeightLbs,
        weightKg,
        age,
        firstName,
      }
    } else {
      const convertedHeightCm = ftInToCm({ ft: heightFt, inch: heightIn })
      const convertedWeightKg = Math.round(lbsToKg(weightLbs))

      return {
        age,
        firstName,
        heightCm: convertedHeightCm,
        heightFt,
        heightIn,
        weightKg: convertedWeightKg,
        weightLbs,
      }
    }
  },
})
